import { ORG_ROUTES, STORE_ROUTES } from '@/config/router';
import type { NotificationItem } from '@/lib/api/notifications';

export function resolveNotificationHref(notification: NotificationItem, orgSlug: string): string | null {
  const orgRoutes = ORG_ROUTES(orgSlug);

  switch (notification.type) {
    case 'WOOCOMMERCE_CREDENTIALS_INVALID':
    case 'WOOCOMMERCE_UNREACHABLE':
      return STORE_ROUTES(orgSlug, notification.payload.storeId).INTEGRATION_CONFIG('woocommerce');
    case 'SHOPIFY_CREDENTIALS_INVALID':
    case 'SHOPIFY_RECONNECT_NEEDED':
    case 'SHOPIFY_BILL_UNPAID':
    case 'SHOPIFY_STORE_UNAVAILABLE':
    case 'SHOPIFY_STORE_DELETED':
    case 'SHOPIFY_STORE_LOCKED':
    case 'SHOPIFY_PERMISSIONS_MISSING':
    case 'SHOPIFY_CONNECTION_RESTORED':
      return STORE_ROUTES(orgSlug, notification.payload.storeId).INTEGRATION_CONFIG('shopify');
    case 'SHOPIFY_CHECKOUT_BUTTON_MISSING':
    case 'SHOPIFY_CHECKOUT_BUTTON_OTHER_STORE':
      return STORE_ROUTES(orgSlug, notification.payload.storeId).STOREFRONT();
    case 'PROCESSOR_CREDENTIALS_INVALID':
      // Edit routes are per processor type and only NMI processors are quarantined today;
      // any other type lands on the details page, which exists for every type.
      return notification.payload.processorType === 'nmi'
        ? orgRoutes.PROCESSOR_EDIT_NMI(notification.payload.processorId)
        : orgRoutes.PROCESSOR_DETAILS(notification.payload.processorId);
    case 'ORDER_SYNC_FAILED':
      return orgRoutes.ORDER_DETAILS(notification.payload.orderId);
    case 'SHOPIFY_ORDERS_REFUSED':
      return orgRoutes.ORDERS();
    case 'WEBHOOK_DELIVERY_FAILING':
    case 'WEBHOOK_ENDPOINT_DISABLED':
      return STORE_ROUTES(orgSlug, notification.payload.storeId).INTEGRATION_CONFIG('webhooks');
    default:
      return null;
  }
}
